<div class="modal-header">
    <h3 class="modal-title">Select invoice to attach orders to</h3>
</div>
<div class="panel-body" id="panelbody">
    <div class="form-group">
        <p>Only pending invoices show below and can have orders attached to them.</p>
        <ngx-datatable
            class="material bxt-table"
            [rows]="rows"
            [rowHeight]="40"
            columnMode="force"
            [headerHeight]="50"
            [footerHeight]="0"
            [virtualization]="false">
            <!-- columns -->
            <ngx-datatable-column name="Invoice #" [sortable]="false" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.InvoiceNumberString }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Description" [sortable]="false" [flexGrow]="3">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.Description }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Select" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <a
                        (click)="selectJobPayment(row)"
                        class="btn btn-xs btn-success"
                        tooltip="Attach to this invoice"
                        container="body"
                        [adaptivePosition]="false"
                        ><i class="ti-link"></i
                    ></a>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-bx-secondary-stroked" (click)="cancel()">Cancel</button>
</div>
